import * as api from '../salesCallApi';
import {
  AddSalesCall,
  ISalesCall,
  salesCallActionCreators,
  SalesCallActionKeys
  } from '..';
import { businessEntityActionCreators } from '../../businessEntity';
import { call, put, takeEvery } from 'redux-saga/effects';
import { IEntityWithMessages } from '../../../services/HttpService';
import { uiActionCreators } from '../../ui';

function* addSalesCallSaga(action: AddSalesCall) {
  yield put(uiActionCreators.showSpinnerDialog());
  try {
    const response: IEntityWithMessages<ISalesCall> = yield call(api.addSalesCall, action.payload);

    if (!response.error && response.value) {
      yield put(salesCallActionCreators.processSalesCalls([response.value]));
      yield put(businessEntityActionCreators.addSalesCalls([response.value]));
    }
    yield put(uiActionCreators.hideSalesCallDialog());
  } catch {
    //
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAddSalesCall() {
  yield takeEvery(SalesCallActionKeys.ADD_SALESCALL, addSalesCallSaga);
}
